var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "search-item",
          {
            attrs: {
              "config-module": "231504",
              "show-simple": false,
              "expand-adv": true,
              "custom-search-items": _vm.customSearchItems,
              no: "1"
            },
            on: { advSearchItemCallBack: _vm.toAdvancedQuery }
          },
          [
            _c(
              "template",
              { slot: "operations" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: !_vm.selectedNode,
                      type: "primary",
                      no: "2"
                    },
                    on: {
                      click: function($event) {
                        return _vm.toLook()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["role_CRMRecoveryCustomerManager_recovery"],
                        expression:
                          "['role_CRMRecoveryCustomerManager_recovery']"
                      }
                    ],
                    attrs: { type: "primary", no: "3" },
                    on: { click: _vm.toRecovery }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Restore")))]
                )
              ],
              1
            )
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "23150102",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                no: "4"
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "23150102",
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize,
                total: _vm.total,
                no: "5"
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: function($event) {
                  return _vm.toAdvancedQuery()
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }